import axios from 'axios';
import helper from '../utils/helper';
// import { history } from '../utils/history';
import { store } from '../utils/store';
import { actionConstants } from './actionConstants';

const getMktMonitorAPI = new RegExp(/^.*\/mKTMonitors\/info(\/.*)*(\?.*)*$/);
axios.interceptors.request.use(
  function (axiosConfig) {
    const apiList = [];
    const _apiList = store.getState().general.apiList;
    if (_apiList.length) {
      apiList.push(_apiList[_apiList.length - 1]);
    }
    apiList.push(axiosConfig.url);
    if (
      apiList.length === 2 &&
      apiList[0] === apiList[1] &&
      apiList[1].match(getMktMonitorAPI)
    ) {
    } else {
      localStorage.setItem('expired', helper.updateExpiredTime());
    }
    store.dispatch({
      type: actionConstants.LOG_API,
      data: apiList,
    });

    return axiosConfig;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);
axios.interceptors.response.use(
  (resp) => {
    if (resp.status === 200 || resp.status === 201 || resp.status === 204) {
      if (resp.data.error) throw resp.data.message;
      if (resp.request.responseType) {
        return resp;
      }
      return resp.data;
    }
  },
  async (error) => {
    console.log('async error');
    console.log(error.response.status);
    const originalRequest = error.config;
    if (originalRequest.url === window.configs.LOGIN_URL) {
      if (error.response.status === 401) {
        console.log('401');
        // history.push('/login');
        // window.location.href = `${window.configs.BASE_URL}/login`;
        store.dispatch({ type: actionConstants.NEED_LOGOUT, data: true });
        return Promise.reject({
          response: {
            data: { error: { message: error.response.data.error_description } },
          },
        });
      }
      if (error.response.status === 500 || error.response.status === 400) {
        // history.push('/login');
        // window.location.href = `${window.configs.BASE_URL}/login`;

        if (
          error.response.data &&
          error.response.data['error_description'] ===
            "The user's password is expired."
        ) {
          store.dispatch({
            type: actionConstants.PASSWORD_IS_EXPIRED,
            data: true,
          });
          return Promise.reject({
            response: {
              data: {
                error: { message: error.response.data.error_description },
              },
            },
          });
        }
        store.dispatch({ type: actionConstants.NEED_LOGOUT, data: true });
        return Promise.reject({
          response: {
            data: { error: { message: error.response.data.error_description } },
          },
        });
      }
    }
    if (error.response) {
      console.log(error.response);
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        console.log('retrying/refresh token');
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const formData = new FormData();
        formData.set('grant_type', 'refresh_token');
        formData.set('refresh_token', userInfo.refresh_token);
        formData.set('client_id', window.configs.client_id);
        formData.set('client_secret', window.configs.client_secret);
        headers.__tenant = window.configs.__tenant;
        let _params = {
          method: 'post',
          url: window.configs.LOGIN_URL,
          headers,
          withCredentials: true,
          data: formData,
        };
        return await axios(_params).then(async (res) => {
          localStorage.setItem(
            'userInfo',
            JSON.stringify({ ...userInfo, ...res }),
          );
          originalRequest.headers.Authorization = `${res.token_type} ${res.access_token}`;
          return await axios(originalRequest);
        });
      }
      if (error.response.status === 404) {
        return Promise.reject({
          response: {
            data: { error: { message: 'Invalid request' } },
          },
        });
      }
    }
    return Promise.reject(error);
  },
);

const headers = {
  'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin': '*',
};
export async function get(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    console.log('get');
    console.log(url);
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let responseType;
    if (params && params.responseType) {
      responseType = params.responseType;
    }
    let _params = {
      method: 'get',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
      responseType,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function post(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    console.log('post');
    console.log(url);
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'post',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data: data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function put(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    console.log('put');
    console.log(url);
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'put',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function _delete(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    console.log('delete');
    console.log(url);
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'delete',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function loginRequest({ username, password }) {
  try {
    const cre = {
      username,
      password,
      grant_type: window.configs.grant_type,
      client_id: window.configs.client_id,
      client_secret: window.configs.client_secret,
    };
    const formBody = Object.keys(cre)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(cre[key]),
      )
      .join('&');
    const _headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      __tenant: window.configs.__tenant,
    };
    let _params = {
      method: 'post',
      url: window.configs.LOGIN_URL,
      headers: _headers,
      withCredentials: true,
      data: formBody,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function changeExpiredPasswordRequest(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    const _headers = {
      __tenant: window.configs.__tenant,
    };
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'put',
      url: `${window.configs.URL}/${url}`,
      headers: { ...headers, ..._headers },
      withCredentials: true,
      data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

async function _results(params) {
  return await axios(params)
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      throw error;
    });
}
